import {
  GET_EMPLOYEE_PROFILE_REQUEST,
  GET_EMPLOYEE_PROFILE_SUCCESS,
  GET_EMPLOYEE_PROFILE_FAILURE,
  UPDATE_EMPLOYEE_PROFILE_REQUEST,
  UPDATE_EMPLOYEE_PROFILE_SUCCESS,
  UPDATE_EMPLOYEE_PROFILE_FAILURE
} from "./ActionType";

const initialState = {
  loading: false,
  employee: null,
  error: "",
}

const employeeProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMPLOYEE_PROFILE_REQUEST:
      return { ...state, loading: true };

    case GET_EMPLOYEE_PROFILE_SUCCESS:
      return { ...state, loading: false, employee: action.payload, error: "" };

    case GET_EMPLOYEE_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_EMPLOYEE_PROFILE_REQUEST:
      return { ...state, loading: true };

    case UPDATE_EMPLOYEE_PROFILE_SUCCESS:
      return { ...state, loading: false, employee: action.payload, error: "" };

    case UPDATE_EMPLOYEE_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
export default employeeProfileReducer